module.exports = "/_next/static/images/ProcessingValidationTransformation@2x-c132585962b61c0ab1a40d029022c080.webp";